export default {
  sections: {
    state: {
      title: 'Status',
      fields: {
        pickup_visible: {
          label: 'Afhalen zichtbaar',
        },
        has_pickup: {
          label: 'Afhalen',
        },
      },
    },
    scheduled_orders: {
      title: 'Geplande bestellingen',
      fields: {
        has_scheduled_orders: {
          label: 'Kunnen klanten vooruitbestellen voor een bepaalde tijd?',
        },
        min_schedule_ahead_time_pickup: {
          label: 'Minimale tijd (minuten) vooruit voor het inplannen van <strong>afhaal</strong>bestellingen',
          placeholder: '30',
        },
        last_order_gap_pickup: {
          label: 'Laatste bestelmoment voor <strong>afhalen</strong> (minuten vóór sluitingstijd)',
          option: '{{value}} min',
        },
      },
    },
    preparation_time_pickup_orders: {
      title: 'Bereidingstijd voor afhaalbestellingen',
      fields: {
        average_order_preparation_time_min: {
          label: 'Bereidingstijd in minuten',
          placeholder: '20',
        },
        average_order_preparation_time_max: {
          label: 'tot',
          placeholder: 'Optioneel',
        },
      },
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    at_least_one_order_method_required:
      'Minimaal 1 bestelmethode (gepland of direct) moet ingeschakeld zijn. Je kunt niet beide uitschakelen.',
  },
};
